import React, { Component } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';

function includesIgnoreCase(source, target) {
    if (!target) {
        return true;
    }
    return String(source || '').toLowerCase().includes(String(target).toLowerCase());
}

function isCurrentEndDate(value) {
    if (!value) {
        return true;
    }
    const normalized = String(value).trim().toLowerCase();
    if (normalized === 'current' || normalized.indexOf('9999-12-31') === 0) {
        return true;
    }
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
        return false;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    parsed.setHours(0, 0, 0, 0);
    return parsed >= today;
}

function displayEndDate(value) {
    return isCurrentEndDate(value) ? 'Current' : value;
}

class GroupDirShGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columnDefs: [
                { field: 'id', headerName: 'dataID', pinned: 'left', cellClass: 'non-number', width: 80, checkboxSelection: true },
                { field: 'entityNameEng', headerName: 'Entity Name(Eng)', pinned: 'left', cellClass: 'non-number', width: 280, tooltipField: 'entityNameEng' },
                { field: 'entityNameOther', headerName: 'Entity Name(Other)', cellClass: 'non-number', width: 220, tooltipField: 'entityNameOther' },
                { field: 'incorpNo', headerName: 'Incorp No', cellClass: 'non-number', width: 140 },
                { field: 'entityCode', headerName: 'Entity Code', cellClass: 'non-number', width: 130 },
                { field: 'incorpPlace', headerName: 'Incorp Place', cellClass: 'non-number', width: 140 },
                { field: 'position', headerName: 'Position', cellClass: 'non-number', width: 140, tooltipField: 'position' },
                { field: 'holdingPct', headerName: 'Holding %', cellClass: 'non-number', width: 120 },
                { field: 'legalNameEng', headerName: 'Legal Name(Eng)', cellClass: 'non-number', width: 220 },
                { field: 'legalNameOther', headerName: 'Legal Name(Other)', cellClass: 'non-number', width: 220 },
                { field: 'effectiveDate', headerName: 'Effective Date', cellClass: 'non-number', width: 140 },
                { field: 'endDate', headerName: 'End Date', cellClass: 'non-number', width: 140, valueFormatter: params => displayEndDate(params.value) },
                { field: 'remarks', headerName: 'Remarks', cellClass: 'non-number', width: 180 },
                { field: 'lastUpdatedBy', headerName: 'Last Updated By', cellClass: 'non-number', width: 150 },
                { field: 'lastUpdateTime', headerName: 'Last Update Time', cellClass: 'non-number', width: 170 },
            ],
            defaultColDef: {
                enableCellChangeFlash: true,
                minWidth: 50,
                sortable: true,
                filter: true,
                resizable: true,
            },
            sideBar: {
                toolPanels: ['columns', 'filters'],
                defaultToolPanel: '',
            },
            rowSelection: 'single',
            context: { componentParent: this },
        };
    }

    onSelectionChanged = event => {
        const rowNodeArray = event.api.getSelectedNodes();
        const selectedGroupDirShArray = rowNodeArray.map(rowNode => rowNode.data);
        this.props.selectGroupDirSh(selectedGroupDirShArray);
    }

    filterRowData = rowData => {
        const { queryFields } = this.props;
        return rowData.filter(item => {
            if (!includesIgnoreCase(item.entityNameEng, queryFields.entityNameEng)) {
                return false;
            }
            if (!includesIgnoreCase(item.position, queryFields.position)) {
                return false;
            }
            if (!includesIgnoreCase(item.legalNameEng, queryFields.legalNameEng)) {
                return false;
            }
            if (queryFields.currentStatus === 'Current' && !isCurrentEndDate(item.endDate)) {
                return false;
            }
            return true;
        });
    }

    render() {
        const {
            queryGroupDirShStatus,
            queryGroupDirShResp,
        } = this.props;

        const isLoading = queryGroupDirShStatus === ACTION_STATUS.LOGINING;
        const groupDirShArray = !!queryGroupDirShResp && !!queryGroupDirShResp.data ? queryGroupDirShResp.data : [];
        const presentDataArray = this.filterRowData(groupDirShArray);

        return (
            <div className='ag-theme-balham grid-wrapper'>
                {isLoading ? (
                    <Loader active content='Loading...' />
                ) : (
                    <AgGridReact
                        columnDefs={this.state.columnDefs}
                        rowData={presentDataArray}
                        defaultColDef={this.state.defaultColDef}
                        rowSelection={this.state.rowSelection}
                        suppressRowClickSelection={true}
                        suppressAggFuncInHeader={true}
                        animateRows={true}
                        immutableData={false}
                        enableRangeSelection={true}
                        context={this.state.context}
                        onSelectionChanged={this.onSelectionChanged}
                        sideBar={this.state.sideBar}
                    />
                )}
            </div>
        );
    }
}

export default GroupDirShGrid;